import { useIntl } from 'react-intl';

import { CURRENCY } from 'src/types';
import { cn } from 'src/utils';

type AmountProps = {
    /** Minor units. Negative for credits - the sign is meaningful, never strip it. */
    value: number | null | undefined;
    /** Optional because some callers take it as an optional prop; Intl throws on undefined. */
    currency?: CURRENCY;
    className?: string;
};

/**
 * Renders money held in minor units.
 *
 * Discounts are stored as negative charges and negative invoice rows, so a negative value is a
 * reduction and is coloured as one. Never wrap the value in Math.abs - totals net by plain addition
 * now, and stripping the sign would silently turn a discount into a charge.
 */
export function Amount({ value, currency = CURRENCY.EUR, className }: AmountProps) {
    const { formatNumber } = useIntl();

    if (value == null) return <span className={className}>-</span>;

    return (
        <span className={cn(value < 0 && 'text-destructive', className)}>
            {formatNumber(value / 100, {
                style: 'currency',
                currency: currency,
            })}
        </span>
    );
}
